import styled from "styled-components";
import { Grey } from "../Colors";

export const ModeWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: ${(props) => (props.mode === "light" ? Grey[50] : Grey[800])};
  }
`;
